import { render } from "./help_popover.vue?vue&type=template&id=50192944&lang=pug"
import script from "./help_popover.vue?vue&type=script&lang=js"
export * from "./help_popover.vue?vue&type=script&lang=js"

import "./help_popover.vue?vue&type=style&index=0&id=50192944&lang=scss"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__